// mui
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "20px",
    width: 260,
    boxShadow: 3,
    fontSize: "1rem",
    fontFamily: '"Poppins", sans-serif',
  },
  header: {
    fontSize: "large",
  },
  dataKey: {
    fontSize: 17,
    fontWeight: 500,
  },
  dataValue: {
    fontSize: 14,
    cursor: "default",
  },
}));

export default useStyles;
